import * as R from 'ramda';
import axios from 'axios';
import logger from 'js/common/logger';
import {mutationInviteRejectByCreator} from '../../graphql/mutations/mutationInviteRejectByCreator';

const requestConfig = {
    responseType: 'json'
};

/**
 * @export
 * @param {string} inviteId
 */
export async function getCampaignInvite(inviteId) {
    const response = await axios.get(`/api/invites/${inviteId}`, requestConfig);
    return response.data.invite;
}

/**
 * @export
 * @param {object} invite
 */
export async function updateCampaignInvite(invite) {
    try {
        const response = await axios.put(`/api/invites/${invite.id}`, {invite}, requestConfig);

        if (invite?.rejectReason) {
            await mutationInviteRejectByCreator(invite);
        }
        
        return response.data.invite;
    } catch (error) {
        logger.error(
            'Failed to update campaign invite for invite id',
            {
                error: error,
                inviteId: invite.id
            }
        );
    }
}

/**
 * @export
 * @param {string} platform
 * @param {number} id
 */
export async function userExists(platform, id) {
    const response = await axios.get(`/api/users/exists/${platform}/${id}`, requestConfig);
    return response.data.exists;
}

/**
 * @export
 * @param {string} brandSlug
 */
export async function getBrandSignupMetadata(brandSlug) {
    const response = await axios.get(`/creator/sign_up/${brandSlug}`, requestConfig);

    return R.pick(['data', 'error'], response);
}



// WEBPACK FOOTER //
// ./creator/onboarding/onboarding_api_client.js